import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { TrialExpiredPage } from '@pages/TrialExpiredPage'
import { userService } from '@services/userService'
import { useAuthStore } from '@store/useAuthStore'

/** Única rota acessível após login quando o período experimental terminou. */
export function SubscriptionRequiredRoute() {
  const { isAuthenticated, checkTokenExpiry, hasApplicationAccess, user, setApplicationAccess } = useAuthStore()

  useEffect(() => {
    if (!user?.id || hasApplicationAccess !== null) {
      return
    }
    userService
      .getEntryLevelStatus()
      .then((status) => {
        setApplicationAccess(status.applicationAccess ?? !status.expired)
      })
      .catch(() => {
        setApplicationAccess(false)
      })
  }, [user?.id, hasApplicationAccess, setApplicationAccess])

  if (!isAuthenticated || !checkTokenExpiry()) {
    return <Navigate to="/login" replace />
  }

  if (hasApplicationAccess === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-secondary-50 text-secondary-600">
        A carregar…
      </div>
    )
  }

  if (hasApplicationAccess !== false) {
    return <Navigate to="/homepage" replace />
  }

  return <TrialExpiredPage />
}
